var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-container"},[_c('qr-code',{attrs:{"value":_vm.link,"size":_vm.size,"level":"H"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }